import { Grid, Text } from '@vtex/shoreline'

import type { InsertionOrderSettingItem } from './hooks/useCampaignInsertionOrderPanelData'

import styles from './styles.module.css'

type SettingsProps = {
  settings?: InsertionOrderSettingItem[] | null
}

export const CampaignInsertionOrderSettings = ({ settings }: SettingsProps) => {
  return (
    <div className={styles.settings}>
      <Grid
        columns="repeat(3, minmax(0, 1fr))"
        gap="$space-5"
        data-testid="campaign-io-settings"
      >
        {(settings ?? []).map(item => (
          <dl key={item?.key} className={styles.settingItem}>
            <dt>
              <Text as="span" variant="caption1" color="var(--sl-fg-base-soft)">
                {item?.label}
              </Text>
            </dt>
            <dd>
              <Text as="div" variant="emphasis">
                {item?.value ?? '—'}
              </Text>
            </dd>
          </dl>
        ))}
      </Grid>
    </div>
  )
}
